import React from 'react';
import ProjectContent from '../components/ProjectContent';

const TranscendLife = () => <ProjectContent projectName='Transcend Life'/>;

export default TranscendLife;